import React, { createContext, useContext, useState, useEffect } from 'react';
import { axios, useAuth } from './AuthContext';

const VeliOgrenciContext = createContext(null);

export const VeliOgrenciProvider = ({ children }) => {
  const { user } = useAuth();
  const [ogrenciler, setOgrenciler] = useState([]);
  const [seciliOgrenci, setSeciliOgrenciState] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user || user.rol !== 'veli') {
      setOgrenciler([]);
      setSeciliOgrenciState(null);
      setLoading(false);
      return;
    }

    let isMounted = true;
    setLoading(true);

    axios.get('/ogrenciler?limit=50')
      .then((res) => {
        if (!isMounted) return;
        const list = res.data?.data || [];
        setOgrenciler(list);

        if (list.length > 0) {
          const savedId = localStorage.getItem('asder_veli_secili_ogrenci_id');
          const found = list.find((o) => String(o.id) === String(savedId));
          const initial = found || list[0];
          setSeciliOgrenciState(initial);
        } else {
          setSeciliOgrenciState(null);
        }
      })
      .catch((err) => {
        console.error('Veli öğrencileri yüklenemedi:', err);
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, [user]);

  const setSeciliOgrenci = (ogrenci) => {
    if (!ogrenci) return;
    setSeciliOgrenciState(ogrenci);
    try {
      localStorage.setItem('asder_veli_secili_ogrenci_id', String(ogrenci.id));
    } catch (_) {}
  };

  const birdenFazla = ogrenciler.length > 1;

  return (
    <VeliOgrenciContext.Provider
      value={{
        ogrenciler,
        seciliOgrenci,
        seciliOgrenciId: seciliOgrenci?.id ?? null,
        setSeciliOgrenci,
        birdenFazla,
        loading,
      }}
    >
      {children}
    </VeliOgrenciContext.Provider>
  );
};

export const useVeliOgrenci = () => {
  const context = useContext(VeliOgrenciContext);
  if (!context) {
    return {
      ogrenciler: [],
      seciliOgrenci: null,
      seciliOgrenciId: null,
      setSeciliOgrenci: () => {},
      birdenFazla: false,
      loading: false,
    };
  }
  return context;
};

export default VeliOgrenciContext;
